export default "/assets/website/images/1920.jpeg?bdc5cbb1faa5f94565ad2d7abb2362aa";